import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { TokenListActionsCell } from './token-list-actions.cell';
import { TokenListActionsHeader } from './token-list-actions.header';

export const TokenListActionsColumn: DisplayColumnDef<
  GatewayTokenModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: TokenListActionsHeader,
  cell: TokenListActionsCell,
};
